import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import SmallCopyBlock from '../blocks/SmallCopy'


import React, { useState, useEffect } from 'react';

import FormCreateAccount from '../forms/CreateAccount';
import LoginForm from '../forms/Login';
import LogoutForm from '../forms/Logout';

import { INTRFAddress, INTRFUser } from '../../hooks/Interfaces';

interface UserAccountProps {
    user: INTRFUser;
    updatecsrf: (value: string) => void;
    updatesession: (value: string) => void;
}

function UserAccount({user, updatecsrf, updatesession}: UserAccountProps){
    const [loggedIn, setLoggedIn] = useState(user.loggedin);
    const [viewLogin, setViewLogin] = useState(false);
    const [viewSignup, setViewSignup] = useState(false);


    const signup = () => {
        setViewLogin(false)
        setViewSignup(true)
    }

    const login = () => {
        setViewSignup(false)
        setViewLogin(true)
    }
    return (
        <> 
            <Container>
                { loggedIn &&
                <Row>
                    <Col>
                        Account Info
                    </Col>

                    <Col xs={{ span: 9 }} className="">
                        <div>
                            <p className="text-start">Delivery Address:</p>
                            <p className="text-start">{user.address.address1}</p>
                            <p className="text-start">{user.address.address2}</p>
                            <p className="text-start">{user.address.city}, {user.address.state} {user.address.zip}</p>
                            
                        </div>
                    </Col>
                </Row>
                }

                { !loggedIn &&
                    <Row className="px-4">
                        <Col className="px-1">
                            <input type="button" className="btn brand-btn-tertiary-color w-100 py-0" value="Create Account" onClick={signup} />
                        </Col>
                        <Col className="px-1">
                            <input type="button" className="btn brand-btn-tertiary-color w-100 py-0" value="Sign In" onClick={login} />
                        </Col>
                    </Row>
                }
                

                

                { loggedIn && <LogoutForm /> }
                
                { !loggedIn && viewLogin && <LoginForm updatecsrf={updatecsrf} updatesession={updatesession} /> }

                { !loggedIn && viewSignup && <FormCreateAccount updatecsrf={updatecsrf} updatesession={updatesession}/> }

            </Container>
        </>
    )
}

export default UserAccount;